import { VideoPlayer, VideoPlayerEvent } from '../../../video/client/video-player';
import { initVideoPlayer } from '../../../_common/client/nexus-interfaces/video';

export class MainImageVideo {
    private static readonly VIDEO_PARENT_ID = 'js_pdp_main-image__video';

    private readonly assetKey: string;
    private readonly trackEvent: (data: Record<string, unknown>) => void;

    private readonly videoElement: HTMLElement;
    private readonly videoWrapperElement: HTMLElement;

    private videoPlayer?: VideoPlayer;

    constructor(assetKey: string, targetElement: HTMLElement, trackEvent: (data: Record<string, unknown>) => void) {
        this.assetKey = assetKey;
        this.trackEvent = trackEvent;

        this.videoElement = document.createElement('div');
        this.videoElement.classList.add('pdp_main-image__video');
        this.videoElement.id = MainImageVideo.VIDEO_PARENT_ID;

        this.videoWrapperElement = document.createElement('div');
        this.videoWrapperElement.classList.add('pdp_main-image__video-wrapper');
        this.videoWrapperElement.appendChild(this.videoElement);

        targetElement.appendChild(this.videoWrapperElement);
    }

    public pause() {
        this.videoPlayer?.pause();
    }

    public async init() {
        if (!this.videoPlayer) {
            this.videoElement.innerHTML = '';
            try {
                this.videoPlayer = await initVideoPlayer({
                    assetKey: this.assetKey,
                    parentId: MainImageVideo.VIDEO_PARENT_ID,
                    backgroundColor: 'transparent',
                    stage: { height: '100%' },
                    autoplay: false,
                    onAspectRatioChange: aspectRatio => {
                        const [width, height] = aspectRatio.split(':');
                        if (width && height) {
                            const relativeVideoHeight = (Number(height) / Number(width)) * 100;
                            this.videoWrapperElement.style.setProperty('--percentage-video-height', String(relativeVideoHeight));
                            this.videoWrapperElement.style.setProperty(
                                '--percentage-video-height-with-unit',
                                String(relativeVideoHeight) + '%'
                            );
                        }
                    },
                    onProgress10: event => this.trackPlayerEvent(event, 'progress_0.1'),
                    onProgress50: event => this.trackPlayerEvent(event, 'progress_0.5'),
                    onProgress90: event => this.trackPlayerEvent(event, 'progress_0.9'),
                    onQualityChange: event => this.trackPlayerEvent(event, 'changeQuality'),
                    onInitialVideoStart: event => this.trackPlayerEvent(event, 'start'),
                    onFullscreenChange: event => this.trackPlayerEvent(event, event.isFullscreen ? 'openFullscreen' : 'closeFullscreen'),
                    onChangeVideo: event => this.trackPlayerEvent(event, 'changeVideo'),
                });
            } catch (error: unknown) {
                this.videoElement.innerHTML = 'Es ist ein technischer Fehler aufgetreten. Bitte rufe das Video erneut auf.';
                this.trackEvent({ product_Video: (error as Error)?.message });
            }
        }
    }

    private trackPlayerEvent(event: VideoPlayerEvent, trackingEventName: string): void {
        this.trackEvent({
            product_Video: trackingEventName,
            product_VideoCount: event.videoCount,
            product_VideoLength: event.videoLength,
            product_VideoPosition: event.videoPosition,
            product_VideoQuality: event.videoQuality,
        });
    }
}
